import { apiInstance } from "api/config/axios";
import { IApiResponse } from "api/models/IApiResponse";
import { LessonFlat } from "models/LessonFlat";
import { getApiResponseData } from "api/services/api-service";
import { IGetLessonsByNodeFileRequest } from "api/models/request/IGetLessonsByNodeFileRequest";
import { ICreateLessonVersionRequest } from "api/models/request/ICreateLessonVersionRequest";
import { ICreateLessonRequest } from "api/models/request/ICreateLessonRequest";

const vrLessonApiBaseUrl = '/VrLesson';

export const addVrLesson = (request: ICreateLessonRequest & { workspaceId: string }): Promise<IApiResponse<string>> => {
    return apiInstance
        .post(`${vrLessonApiBaseUrl}/workspaces/${request.workspaceId}/create`, request)
        .then((response) => getApiResponseData(response));
};

export const getLessonsByNodeFile = (
    request: IGetLessonsByNodeFileRequest & { workspaceId: string }
): Promise<IApiResponse<LessonFlat[]>> => {
    return apiInstance
        .get(`${vrLessonApiBaseUrl}/all/workspaces/${request.workspaceId}/node-files/${request.nodeFileId}`)
        .then((response) => getApiResponseData(response));
};

export const createLessonVersion = (
    request: ICreateLessonVersionRequest & { workspaceId: string }
): Promise<IApiResponse<string>> => {
    return apiInstance
        .post(
            `${vrLessonApiBaseUrl}/${request.lessonId}/workspaces/${request.workspaceId}/versions`,
            request
        )
        .then((response) => getApiResponseData(response));
};
